export const educationActionType = {
  ALL_EDUCATION_REQUEST: "ALL_EDUCATION_REQUEST",
  ALL_EDUCATION_FAIL: "ALL_EDUCATION_FAIL",
  ALL_EDUCATION_SUCCESS: "ALL_EDUCATION_SUCCESS",

  SINGLE_EDUCATION_REQUEST: "SINGLE_EDUCATION_REQUEST",
  SINGLE_EDUCATION_FAIL: "SINGLE_EDUCATION_FAIL",
  SINGLE_EDUCATION_SUCCESS: "SINGLE_EDUCATION_SUCCESS",

  CREATE_EDUCATION_REQUEST: "CREATE_EDUCATION_REQUEST",
  CREATE_EDUCATION_FAIL: "CREATE_EDUCATION_FAIL",
  CREATE_EDUCATION_SUCCESS: "CREATE_EDUCATION_SUCCESS",

  DELETE_EDUCATION_REQUEST: "DELETE_EDUCATION_REQUEST",
  DELETE_EDUCATION_FAIL: "DELETE_EDUCATION_FAIL",
  DELETE_EDUCATION_SUCCESS: "DELETE_EDUCATION_SUCCESS",

  UPDATE_EDUCATION_REQUEST: "UPDATE_EDUCATION_REQUEST",
  UPDATE_EDUCATION_FAIL: "UPDATE_EDUCATION_FAIL",
  UPDATE_EDUCATION_SUCCESS: "UPDATE_EDUCATION_SUCCESS",
};
